<template>
  <div>

    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="회원 조회"
      desc="가입한 회원들의 현황을 조회할 수 있습니다."
    >
      <div slot="agreement">
        <lp-radio label_name="label" value_name="value" :data="agreement_arr" @onSelect="clickAgreement"></lp-radio>
      </div>
    </admin-filter>

    <div class="btn-group-justify-end" v-if="page!=='purchase'">
      <button @click="$router.push('user/create')"
              class="button is-primary">회원 등록</button>
    </div>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1500"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <div slot="purchase" slot-scope="props" v-if="page==='purchase'" style="width: 80px">
        <button class="button half" @click="selectUser(props.item)">선택</button>
      </div>

      <div slot="country" slot-scope="props">{{ props.item.country === 'fr' ? '프랑스' : '독일' }}</div>

      <div slot="created_time" slot-scope="props">
        <div style="white-space: pre-line">{{ props.item.created_time.replace(/ /gi, '\n') }}</div>
      </div>

      <div slot="name" slot-scope="props" style="cursor:pointer;text-decoration:underline">
        <span @click="detailLink(props.item.id)">{{ props.item.last_name }}{{ props.item.name }}</span>
      </div>

      <!--<div slot="partner" slot-scope="props">
        {{ isPartnerUser(props.item) }}
      </div>-->

      <div slot="guest" slot-scope="props">{{ props.item.guest ? '비회원' : '회원' }}</div>

      <div slot="paid_user" slot-scope="props" @click="detailService(props.item)"
          class="unselect">{{ props.item.paid_user ? 'O' : '-' }}</div>

      <div slot="login_type" slot-scope="props">
        {{ convertLoginType(props.item.login_type) }}
      </div>

      <div slot="service_count" slot-scope="props">
        <span class="unselect" style="text-decoration:underline" @click="detailService(props.item)">{{ props.item.service_count }}</span>
      </div>



      <div slot="modify_delete" slot-scope="props">
        <button class="button half"
                @click.stop.prevent="clickItem(props.item,'update')" style="margin-right:4px">수정</button>
        <button class="button half is-danger"
                @click.stop.prevent="clickItem(props.item,'delete')">삭제</button>
      </div>

      <div slot="is_mail" slot-scope="props">
        <span v-if="props.item.is_mail">발송됨</span>
        <span v-else>발송안됨</span>
      </div>
    </admin-table>

    <!-- 메일 전송 팝업 -->
    <modal name="mailModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <div>이메일을 발송하시겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('mailModal')">취소</button>
          <button class="button is-primary" @click="sendMail">확인</button>
        </div>
      </div>
    </modal>

  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'
  import LpRadio from "../../module/common/LpRadio";

  export default {
    name: 'UserList',
    components: {LpRadio},
    mixins: [
      ListMixin  // 목록페이지의 공통적인 데이터 및 함수는 List.js에 다 구성되어 있다.
    ],
    props: ['page'],
    data() {
      return {
        user_id: 0,
        agreement_arr: [
          {
            label: 'sms 수신동의',
            value: 'sms'
          },
          {
            label: '이메일 수신동의',
            value: 'email'
          },
          {
            label: '앱푸시 수신동의',
            value: 'push'
          }
        ]
      }
    },
    watch: {
      '$store.state.internalPlugin'(n) {
        this.rebuildFilterData();
      }
    },
    created(){
      this.$route.meta.isRefresh = false;
      this.init();
    },
    methods: {
      init() {
        /* 테이블, 필터를 구성할 structure_path, url을 파라미터로 넘겨준다.
      *  structure.js에 structure_path에 맞게 데이터를 생성한다.
      *  해당 url에 맞게 axios 호출이 잘되는지 확인한다.
      * */
        this.initializing(this.isLaunchpack ? 'lp_member_user' : 'member_user', 'member/user');
        this.filtered.ordering = '-created_time';
        // 유저 맞춤 DB 필터링 추가
        let filterData = this.filterData.filter(item => { return item.title === '통합검색' })[0];
        if(filterData.options.filter(item => { return item.value && item.value.indexOf('param__')> -1 }).length === 0) {
          this.$axios.get(this.getUrl('member/user/param?page_length=1000')).then(res => {
            let data = Array.isArray(res.data) ? res.data : res.data.data;
            data.forEach(item => {
              if(item.type === 'text') {
                filterData.options.push({
                  label: item.name,
                  value: `param__${item.name}`
                })
              }
            });
          });
        }

        this.getPackages();

        // 수기 주문 페이지에서 회원 페이지를 모달로 띄울 경우
        if(this.page === 'purchase') {
          if(this.tableData[0].eng_name !== 'purchase') {
            this.tableData.splice(0, 0, {
              eng_name: 'purchase',
              ko_name: '',
              width: '70px'
            });
          }

          for(let i=0; i<this.tableData.length; i++){
            if(this.tableData[i].eng_name==='modify_delete') {
              this.tableData.splice(i, 1);
            }
          }
        }
        else {
          // modify_delete 키 유무에 따른 처리
          let is_key = false;
          for(let x=0; x<this.tableData.length; x++){
            if(this.tableData[x].eng_name === 'exhibition') {
              this.tableData.splice(x, 1);
            }
            else if(this.tableData[x].eng_name === 'modify_delete'){
              is_key = true;
              break;
            }
          }
          if (!is_key) {
            this.tableData.push({eng_name: 'modify_delete', ko_name:'수정/삭제', width: '120px'});
          }
        }

        // 맞춤DB 필드 추가
        this.$axios.get('/admin/member/user/param?ordering=id&page_length=1000').then(res => {
          let data = Array.isArray(res.data) ? res.data : res.data.data;
          data.forEach(item => {
            if(['text','choice_checkbox'].indexOf(item.type)>-1) {
              let data = find(this.tableData, 'ko_name', item.name);
              if(!data) {
                this.tableData.splice(this.tableData.length-1, 0, {
                  eng_name: `param.${item.name}`,
                  ko_name: item.name,
                  ordering: false,
                  width: '100px'
                })
              }
            }

          });

        });

      },
      getDataFromServer() {
        this.getData();
      },
      convertLoginType(name) {
        const types = {
          email: '이메일',
          kakao: '카카오',
          naver: '네이버',
          facebook: '페이스북',
          google: '구글',
          apple: '애플'
        };
        return types[name];
      },
      isPartnerUser(item) {
        return item.partner ? 'O' : '-';
      },
      // 이메일 모달 오픈
      openMailModal(id) {
        this.$modal.show('mailModal');
        this.user_id = id;
      },
      // 회원가입 축하 메일 발송
      sendMail() {
        this.$store.commit('setLoading', true);
        this.$axios.post(this.getUrl(`user/sign/success/mail?id=${this.user_id}`)).then(res=>{
          if(res.status===200){
            this.toast('메일이 전송되었습니다.');
            this.$modal.hide('mailModal');
            this.$store.commit('setLoading', false);

            for(let i=0; i<this.tableItems.length; i++) {
              if(this.tableItems[i].id === this.user_id) {
                this.tableItems[i].is_mail = true;
                this.user_id = 0;
                break;
              }
            }
          }
        })
      },
      detailLink(id) {
        this.$router.push(this.getPath(`user/create?id=${id}`))
      },
      addTableItem(eng_name, ko_name, width) {
        if(this.tableData.findIndex(i=>{return i.eng_name === eng_name})===-1) {
          this.tableData.splice(this.tableData.length-1, 0, {
            eng_name: eng_name,
            ko_name: ko_name,
            width: width
          })
        }
      },
      getPackages(){
        let packages = this.$store.getters.getPackages;
        // 마스터 백오피스 경우 이메일 인증 / 강제인증 / 인증안됨 값 구분이 필요해서 인증 구분 컬럼을 추가해야함.
        if(packages[0].name==='launchpack') {
          /*let isType = false;
          this.tableData.forEach(item=>{
            if(item.eng_name==='auth_type') isType = true;
            if(item.eng_name === 'partner') {
              item.ko_name = '개발자 계정';
            }
            if(item.eng_name === 'login_type') {
              item.eng_name = 'channel';
            }
          });
          if(!isType) {
            this.tableData.splice(1, 0, {
              eng_name: 'guest',
              ko_name: '회원여부',
              width: '60px'
            })
            this.addTableItem('is_mail', '발송 여부', '100px');
            this.addTableItem('service_count', '개설된 서비스', '150px');
          }*/
        }
        else {
          [
            {
              pack: 'call',
              kor_name: '전화연결'
            },
            {
              pack: 'reservation',
              kor_name: '시간예약'
            },
            {
              pack: 'booking',
              kor_name: '기간예약'
            },
            {
              pack: 'delivery',
              kor_name: '배송주문'
            },
            {
              pack: 'mart',
              kor_name: '배달주문'
            },
          ].forEach(item=>{
            if (find(packages, 'name', item.pack)) {
              this.addTableItem(`${item.pack}_count`, item.kor_name + ' 건수', '120px');
            }
          });
        }
      },
      clickItem(item, types) {
        // 수정
        if (types === 'update') {
          this.$router.push(this.getPath('user/create?id=' + item.id));
        }
        // 삭제
        else if (types === 'delete') {
          if(this.isLaunchpack) {
            if(item.service_count>0) {
              alert(`이용 중인 서비스가 ${item.service_count}개 있습니다. 서비스 이용을 먼저 종료하고 삭제할 수 있습니다.`)
              return;
            }
          }
          let value = {
            id: item.id,
            url: 'member/user/',
            title: '회원을 탈퇴시키겠습니까?'
          }
          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
        }
      },
      selectUser(user){
        this.$emit('selectUser', user);
      },
      rebuildFilterData() {
        // 회원 등급 플러그인 사용 여부에 따라 (비)활성화
        if(!this.isInternalPlugin('user_grade')) {
          let idx = this.filterData.findIndex(item => {return item.key === 'grade'});
          if(idx>-1) removeIndex(this.filterData, idx);
        }
      },
      clickAgreement(val) {
        delete this.filtered.sms_agreement;
        delete this.filtered.email_agreement;
        delete this.filtered.push_agreement;
        if(val==='sms') {
          this.filtered.sms_agreement = true;
        } else if(val==='email') {
          this.filtered.email_agreement = true;
        } else if(val==='push') {
          this.filtered.push_agreement = true;
        }
        this.getData()
      },
      detailService(item) {
        if(item.service_count>0) {
          this.routerPush(this.getPath(`launchpack/service?email=${item.email}`));
        }
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>

</style>
